import styled, { css } from 'styled-components';
import { pxToRem } from '../../../design-tokens/style-utilities';
import { NAVIGATION_GRID_AREAS, NAVIGATION_MAIN_SIZES, NAVIGATION_MAX_WIDTH, NAVIGATION_VIEWPORT_BREAKPOINTS, } from '../constants';
export const navigationContainerStyles = ({ theme, $isOpen, }) => css `
	z-index: ${theme.zIndex.menu};
	position: relative;
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	padding: 0 ${pxToRem(theme.spacing['50'])} 0 ${pxToRem(theme.spacing['200'])};
	background-color: ${theme.colors.blanc.bgMainNavigation};

	${$isOpen &&
    css `
		z-index: ${theme.zIndex.menu};
		position: fixed;
		top: 0;
		right: 0;
		left: 0;
		overflow: hidden auto;
		padding: 0 ${pxToRem(theme.spacing['200'])};

		/* Give extra space for Safari UI on older iOS devices that don't supper dvh yet */
		height: 100vh;

		@media (max-height: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.md)}) {
			padding-bottom: 20vh;
		}

		@supports (height: 100dvh) {
			height: 100dvh;
			padding-bottom: 0;
		}
	`};

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		padding: 0;
		border-bottom: ${theme.borderWidth['2']}px solid ${theme.colors.accent.bgMainNavigation};

		${$isOpen &&
    css `
			position: relative;
			top: unset;
			right: unset;
			left: unset;
			height: unset;
			overflow: clip visible;
		`}
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.xl)}) {
		margin: 0;
		align-items: center;
	}
`;
export const NavigationContainer = styled.div `
	${navigationContainerStyles}
`;
/**
 * Navigation inner
 */
export const navigationInnerStyles = () => css `
	flex: 1;
	display: grid;
	grid-template-areas:
		'${NAVIGATION_GRID_AREAS.LEFT} ${NAVIGATION_GRID_AREAS.ACTIONS} ${NAVIGATION_GRID_AREAS.TOGGLE}'
		'${NAVIGATION_GRID_AREAS.MAIN} ${NAVIGATION_GRID_AREAS.MAIN} ${NAVIGATION_GRID_AREAS.MAIN}'
		'${NAVIGATION_GRID_AREAS.SECONDARY} ${NAVIGATION_GRID_AREAS.SECONDARY} ${NAVIGATION_GRID_AREAS.SECONDARY}';
	grid-template-columns: 1fr auto auto;
	grid-template-rows: ${pxToRem(NAVIGATION_MAIN_SIZES.sm)} 1fr auto;
	align-items: center;
	max-width: ${pxToRem(NAVIGATION_MAX_WIDTH)};

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.md)}) {
		grid-template-columns: auto 1fr auto;
		grid-template-rows: ${pxToRem(NAVIGATION_MAIN_SIZES.md)} 1fr auto;
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		position: relative;
		flex: unset;
		grid-template-areas:
			'${NAVIGATION_GRID_AREAS.SECONDARY} ${NAVIGATION_GRID_AREAS.SECONDARY} ${NAVIGATION_GRID_AREAS.SECONDARY} ${NAVIGATION_GRID_AREAS.SECONDARY}'
			'${NAVIGATION_GRID_AREAS.LEFT} ${NAVIGATION_GRID_AREAS.MAIN} ${NAVIGATION_GRID_AREAS.ACTIONS} ${NAVIGATION_GRID_AREAS.TOGGLE}';
		grid-template-columns: auto auto 1fr 0;
		grid-template-rows: auto ${pxToRem(NAVIGATION_MAIN_SIZES.lg)} auto;
		height: unset;
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.xl)}) {
		margin: 0;
		align-items: center;
		width: 100%;
	}
`;
export const NavigationInner = styled.div `
	${navigationInnerStyles}
`;
